var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBostaBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1554_80490)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74902 17.25H16.9041",
    stroke: "#111619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4648 7.1661L11.6662 8.18329L7.20339 3.68078L4.92424 4.2911L7.86804 9.20117L5.58928 9.81217L3.66296 8.69961L1.38421 9.31061L4.88428 13.2575L16.2782 10.2043C16.6753 10.0913 17.012 9.82667 17.2157 9.46756C17.4194 9.10845 17.4737 8.68365 17.367 8.28484C17.2602 7.88603 17.0009 7.54519 16.645 7.33589C16.2892 7.12658 15.8653 7.0656 15.4648 7.1661Z",
    stroke: "#111619",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1554_80490"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBostaBox);
export default __webpack_public_path__ + "477fde584f6ed83b010990a48655b57d.svg";
export { ForwardRef as ReactComponent };